import { clientGroupService } from '../../helpers/services/clientGroup.service'
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  list: [],
  details: null,
}

export const CLIENT_GROUP_MODULE = 'clientGroup'

export const GET_ALL_CLIENT_GROUPS = 'getAllClientGroups'
export const GET_CLIENT_GROUP = 'getClientGroup'
export const CREATE_CLIENT_GROUP = 'createClientGroup'
export const UPDATE_CLIENT_GROUP = 'updateClientGroup'
export const DELETE_CLIENT_GROUP = 'deleteClientGroup'

const LIST_SUCCESS = 'listSuccess'
const DETAIL_SUCCESS = 'detailSuccess'

export const actions = {
  [GET_ALL_CLIENT_GROUPS]({ commit }) {
    return clientGroupService.getAll().then((r) => {
      commit(LIST_SUCCESS, r)
      return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_CLIENT_GROUP]({ commit }, { id }) {
    return clientGroupService.getOne(id).then((r) => {
      commit(DETAIL_SUCCESS, r)
      return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [CREATE_CLIENT_GROUP]({ dispatch }, { data }) {
    return clientGroupService.create(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.createX', ['Client Group']))
      dispatch(GET_ALL_CLIENT_GROUPS)
      return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [UPDATE_CLIENT_GROUP]({ dispatch }, { id, data }) {
    return clientGroupService.update(id, data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', ['Client Group']))
      dispatch(GET_ALL_CLIENT_GROUPS)
      return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [DELETE_CLIENT_GROUP]({ dispatch }, { id }) {
    return clientGroupService.remove(id).then((r) => {
      dispatch(GET_ALL_CLIENT_GROUPS)
      return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, r) { state.list = r?.data || [] },
  [DETAIL_SUCCESS](state, r) { state.details = r?.data || null },
}
